import Vue from 'vue'

import { LOCAL_STORAGE_KEYS } from '@/constants'

const SESSION_STORAGE_LAST_ACTIVE_LOCATION_KEY = 'lastActiveLocationId'

function clearBasketIfActiveLocationChanged (activeLocationId) {
  if (!activeLocationId) {
    return
  }
  const normalizedActiveLocationId = String(activeLocationId)
  const lastActiveLocationId = sessionStorage.getItem(SESSION_STORAGE_LAST_ACTIVE_LOCATION_KEY)
  if (lastActiveLocationId && lastActiveLocationId !== normalizedActiveLocationId) {
    try {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.basket)
    } catch (e) { /* ignore */ }
  }
  sessionStorage.setItem(SESSION_STORAGE_LAST_ACTIVE_LOCATION_KEY, normalizedActiveLocationId)
}

export default {
  namespaced: true,
  state: {
    profile: {
      user: Object.assign({
        clientId: null,
        userId: null,
        userName: null,
        email: null,
        roles: [],
        securityLevel: null,
        approvalStatus: null
      }, window.userProfile || {}),

      locations: Object.assign({
        userLocations: [],
        locationRequests: [],
        activeLocationId: null
      }, window.userLocations || {})
    }
  },
  getters: {
    get: state => state.profile,
    getUserId: state => state.profile.user.userId,
    getLocations: state => state.profile.locations,
    getActiveLocationId: state => state.profile.locations.activeLocationId || (state.profile.locations.userLocations[0] || {}).locationId || null
  },
  mutations: {
    initializeActiveLocationTracking (state) {
      clearBasketIfActiveLocationChanged(state.profile.locations.activeLocationId)
    },
    setLocations (state, locations = []) {
      const userLocations = locations.filter(l => l.isAccepted === true)
      const locationRequests = locations.filter(l => l.isAccepted === false)

      Vue.set(state.profile.locations, 'userLocations', userLocations)
      Vue.set(state.profile.locations, 'locationRequests', locationRequests)
    },
    setActiveLocationId (state, locationId = null) {
      clearBasketIfActiveLocationChanged(locationId)
      Vue.set(state.profile.locations, 'activeLocationId', locationId)
    }
  },
  actions: {
    /**
     * Switches active location like the header location flyout: full navigation with ?setCurrentLocation=.
     * Layout ScriptProfile persists the location, then runs OpenID Connect so Identity re-issues tokens
     * (selected-location-id in the Bearer token for Service Platform APIs).
     */
    setActiveLocationId (context, locationId = null) {
      if (!locationId) {
        return Promise.resolve()
      }
      const url = new URL(window.location.href)
      url.searchParams.set('setCurrentLocation', locationId)
      window.location.assign(url.toString())
      return new Promise(() => {})
    }
  }
}
